// extracted by mini-css-extract-plugin
module.exports = {"section":"ISO_section_1h0K7"};